import React from "react";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export function SortableItem({id, children, className, style, useDragHandle}) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: id,
  });

  const compStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 999 : "auto",
    position: "relative", // Ensures z-index works
    ...style, // Allow passing additional styles if needed
  };

  if (useDragHandle) {
    return (
      <div ref={setNodeRef} style={compStyle} className={className}>
        {typeof children === 'function' ? children({listeners, attributes}) : children}
      </div>
    );
  }

  return (
    <div ref={setNodeRef} style={compStyle} className={className} {...attributes} {...listeners}>
      {children}
    </div>
  );
}
